import React, { useState } from 'react';
import SampleDashboardLayout from './SampleDashboardLayout';
import { useFormik } from 'formik';
import { userProfileUpdateSignUpSchema } from '../../../schemas/UserUpdateProfileSchema';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserProfileAPI } from '../../../redux/slices/UpdateUserProfile';
import { base, errorHandler } from '../../../constants/base';
import { toast } from 'react-toastify';
import { updateUser } from '../../../redux/slices/authSlice';

const SampleProfilePage = () => {

    const dispatch = useDispatch();
    const loading = useSelector(state => state.UpdateUserProfileSlice.loading);

    const loggedInUser = useSelector((state) => state.AuthSlice.user);
    const [isEditable, setIsEditable] = useState(false);

    const [profile, setProfile] = useState("")
    const [showProfileImage, setShowProfileImage] = useState("")

    const formik = useFormik({
        initialValues: {
            id: loggedInUser?.id || '',
            name: loggedInUser?.name || '',
            email: loggedInUser?.email || '',
            ss_number: loggedInUser?.ss_number || '',
            about: loggedInUser?.about || '',
            profile: profile,
        },
        validationSchema: userProfileUpdateSignUpSchema,
        onSubmit: async (values) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                formData.append(key, values[key]);
            });

            const res = await dispatch(updateUserProfileAPI(formData));

            if (res.type === 'updateUserProfileAPI/fulfilled') {
                setIsEditable(false);
                if (res?.payload?.success || res?.payload?.status === 200) {
                    toast.success('Profile updated successfully!');
                    dispatch(updateUser(res.payload.data.data))
                } else {
                    errorHandler(res?.payload?.errors);
                }
            } else if (res.type === 'updateUserProfileAPI/rejected') {
                errorHandler(res?.payload?.errors);
                setIsEditable(false);
            } else {
                toast.error('Sorry, something went wrong!');
                setIsEditable(false);
            }
        },
    });

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setShowProfileImage(previewUrl);
            formik.setFieldValue("profile", file);
        }
    };

    return (
        <SampleDashboardLayout>
            <div className="add-employee-box">
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3 custom-input-box">
                        <label>Full Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formik.values.name}
                            disabled={!isEditable}
                            onChange={formik.handleChange}
                        />
                        {formik.errors.name && formik.touched.name && (
                            <div className="error-message">{formik.errors.name}</div>
                        )}
                    </div>

                    <div className="mb-3 custom-input-box">
                        <label>Email Address</label>
                        <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={formik.values.email}
                            disabled
                        />
                    </div>

                    <div className="mb-3 custom-input-box">
                        <label>Social Security Number</label>
                        <input
                            type="text"
                            className="form-control"
                            name="ss_number"
                            value={formik.values.ss_number}
                            disabled={!isEditable}
                            onChange={formik.handleChange}
                        />
                        {formik.errors.ss_number && formik.touched.ss_number && (
                            <div className="error-message">{formik.errors.ss_number}</div>
                        )}
                    </div>

                    <div className="mb-3 custom-input-box">
                        <label>About Yourself</label>
                        <textarea
                            className="form-control"
                            name="about"
                            value={formik.values.about}
                            disabled={!isEditable}
                            onChange={formik.handleChange}
                        />
                        {formik.errors.about && formik.touched.about && (
                            <div className="error-message">{formik.errors.about}</div>
                        )}
                    </div>

                    <div className="logo-box">
                        <h3 className="second-text-heading">Profile Picture</h3>
                        <img
                            src={showProfileImage || `${base.imageUrl}${loggedInUser?.images[0]?.path}`}
                            alt="Profile"
                            style={{ width: '100px', height: '100px', borderRadius: '50%', marginBottom: '10px', objectFit: "cover" }}
                        />
                        {isEditable && (
                            <div>
                                <label htmlFor="upload-image" className="upload-image">
                                    <span>Upload Image</span>
                                </label>
                                <input
                                    type="file"
                                    className="d-none"
                                    id="upload-image"
                                    onChange={handleFileChange}
                                />

                            </div>
                        )}
                    </div>

                    <div className="submit-btn-form mb-3">
                        {isEditable ? (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => formik.handleSubmit()}
                                disabled={loading}
                            >
                                {!loading ? 'Save' : <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: '22px' }} />}
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setIsEditable(true)}
                            >
                                Edit
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </SampleDashboardLayout>
    );
};

export default SampleProfilePage;